<template>
  <div>
    <span :class="{ 'text-left': true, required: required }">
      {{ label }}
    </span>
    <div class="quantity_control">
      <span
        v-on:click="numberInput -= 1"
        v-bind:disabled="numberInput < 1"
        class="minus_plus"
      >
        <i class="fa fa-minus">-</i>
      </span>
      <input
        v-model.number="numberInput"
        class="text-center form-control"
        type="number"
        min="1"
        max="10"
      />
      <span v-on:click="numberInput += 1" class="minus_plus">
        <i class="fa fa-plus">+</i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "LabelNumberInput",
  props: {
    height: {
      type: [Number, String],
      default: 41,
    },
    width: {
      type: [Number, String],
      default: 41,
    },
  },
  data() {
    return {
      numberInput: 1,
    };
  },
  watch: {
    numberInput: function () {
      this.$emit("change", this.numberInput);
    },
  },
};
</script>

<style scoped>
.text-center {
  text-align: center;
}
span {
  display: flex;
  font-size: 0.75rem;
  font-weight: bold;
  color: #b0bac9;
  padding-bottom: 0.5rem;
}

.required::after {
  content: "*";
  margin-left: 0.25rem;
  color: red;
}

.unit {
  width: 3.25rem;
  height: 1.875rem;
  padding-bottom: 0;
  border: 1px solid #e0e7ff;
  border-radius: 0.3125rem;
  background: white;
}

.unit span {
  font-size: 1.125rem;
  font-weight: 500;
  color: #7b7b7b;
}
.form-control{
  height: 41px;
  border-radius: 0;
  border-left: 1px solid #E0E7FF;
  border-right: 1px solid #E0E7FF;
  border-top: 0px solid #E0E7FF;
  border-bottom: 0px solid #E0E7FF;
}
.quantity_control{
  display: flex; align-items: center;
  width: 123px;
  border: 1px solid #E0E7FF;
  box-sizing: border-box;
  border-radius: 5px;
}
.minus_plus{
  padding: 7px 16px;  
  color: #000000;
  font-weight: 500;
  font-size: 18px;
  font-family: Arial;
  text-transform: uppercase;
  background: rgba(224, 231, 255, 0.2);
}
</style>